import { render } from "./view.vue?vue&type=template&id=75a8a2fe&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"

import "./view.vue?vue&type=style&index=0&id=75a8a2fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-75a8a2fe"

export default script